<div class="h-20"></div>
<header
  class="fixed top-0 w-full z-50 bg-white shadow-md transition-all duration-300 ease-in-out"
>
  <app-navigation></app-navigation>
</header>
